// Football — a separate lobby tile that reuses the sports lobby (shared cricket engine,
// sport-scoped). The lobby defaults to the Football tab from the /games/football route.
import type { GameModule } from '../types';
import Page from '../cricket/Page';

const football: GameModule = {
  id: 'football',
  displayName: 'Football',
  tag: "Sports",
  theme: { gradient: 'from-[#0B4D2E] via-[#052e16] to-[#001A00]', emoji: '⚽' },
  orientation: 'any',
  Page,
};

export default football;
